import Component from './ChatButton';
import Container from './ChatButton.container';

export default Container(Component);
